import { render, staticRenderFns } from "./knowledge-management.vue?vue&type=template&id=5455738c&"
import script from "./knowledge-management.vue?vue&type=script&lang=js&"
export * from "./knowledge-management.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports